import { DEMO_ACCOUNT_IDS, DEMO_USER_EMAIL } from '@/constants';

export const isDemoAccount = (accountId: string): boolean =>
  DEMO_ACCOUNT_IDS.includes(accountId);

export const isDemoUser = (email: string | null | undefined): boolean =>
  email === DEMO_USER_EMAIL;

export const isDemoSubdomain = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.location.hostname.split('.')[0] === 'demo';
};

// Fake delay for mutations (300-800ms)
export const fakeMutationDelay = () =>
  new Promise(resolve => setTimeout(resolve, 300 + Math.random() * 500));
